module.exports = __webpack_public_path__ + "img/02.ece22274.png";